import React from 'react';
import { NodeEntity } from './Node/NodeDefinition';

interface NodeContextProps {
  node: NodeEntity,
}

export const NodeContext = React.createContext<NodeContextProps>({

} as any);